import { resumidoCarouselGenerico } from './carousel-generico';
import { resumidoCarouselManoAMano } from './mano-a-mano';

export const RESUMIDO_TEMPLATES = [resumidoCarouselGenerico, resumidoCarouselManoAMano] as const;

export * from './carousel-generico';
export * from './mano-a-mano';
